module.exports = __webpack_public_path__ + "img/jingmi900g.3c7b58e6.jpg";